import React, {useEffect, useRef, useState} from 'react'
import {CertificateCanvasView} from './CertificateCanvasView'
import {CERT_ARTBOARD_H, CERT_ARTBOARD_W, CertificateRenderModel} from './certificateTypes'

type Props = {
  model: CertificateRenderModel
}

export const CertificateViewer: React.FC<Props> = ({model}) => {
  const wrapRef = useRef<HTMLDivElement>(null)
  const [scale, setScale] = useState(1)
  const docW = model.document.width || CERT_ARTBOARD_W
  const docH = model.document.height || CERT_ARTBOARD_H

  useEffect(() => {
    const el = wrapRef.current
    if (!el) return

    const updateScale = () => {
      const available = el.clientWidth || docW
      setScale(Math.min(1, Math.max(0.42, (available - 8) / docW)))
    }

    updateScale()
    const observer = new ResizeObserver(updateScale)
    observer.observe(el)
    return () => observer.disconnect()
  }, [docW])

  return (
    <div className='certificate-viewer' ref={wrapRef}>
      <div
        className='certificate-viewer__frame'
        style={{width: `${docW * scale}px`, height: `${docH * scale}px`}}
      >
        <div
          className='certificate-viewer__scaler'
          style={{width: `${docW}px`, height: `${docH}px`, transform: `scale(${scale})`}}
        >
          <CertificateCanvasView document={model.document} context={model.context} />
        </div>
      </div>
    </div>
  )
}
